
(function(app) {
    app.menufix = (function() {
        var initialized = false;


        var classes = {
            isFixed: 'is-fixed'
        };


        var selectors = {
            nav :  '.image-nav-section-has-fix'
        };

        var vars = {
             gap        : '',
             scrollTop  : ''
        };


        var init = function() {
            initialized = true;

            app.$objs.nav = $(selectors.nav);

            bind();
        };


        var bind = function() {
            toggleIsFixed();

            $(window).on('scroll' , function () {
                toggleIsFixed();
            });
        };


        var findGap = function () {
            if($(selectors.nav).length>0) {
                vars.gap = $(selectors.nav).offset().top;
                return vars.gap;
            }
        }; 


        var findScrollTop = function () {
            vars.scrollTop = (document.documentElement && document.documentElement.scrollTop) ||document.body.scrollTop;
            return vars.scrollTop;
        };

        var addIsFixed = function () {
            app.$objs.nav.addClass(classes.isFixed);
        };

        var removeIsFixed = function () {
            app.$objs.nav.removeClass(classes.isFixed);
        };

        var gap = findGap() / 2;

        var toggleIsFixed = function () {
          if(gap > findScrollTop()) {
              removeIsFixed();
          }
          else {
              addIsFixed();
          }
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('menufix');
})(pc);
